import { ChevronRightOutlineIcon } from '@ikyucom/design-system-icons-react'
import { useCallback, useState } from 'react'
import Image from '~/components/image/Image'
import { getFragmentData } from '~/lib/graphql'
import { Link } from '~/navigation'
import { css } from '~/styled-system/css'
import { RestaurantPhotos } from '../RestaurantPhotos.frag'
import type { ImageThumbnailProps } from '../types'
import { PhotoThumbnailModal } from './PhotoThumbnailModal'

export function ImageThumbnail({ restaurantId, restaurant }: ImageThumbnailProps) {
  const [showModal, setShowModal] = useState(false)
  const [index, setIndex] = useState(0)

  const { images, name: restaurantName } = getFragmentData(RestaurantPhotos, restaurant)
  // ガイドのサムネイルには6枚の画像を表示するため、抽出
  const imagesForThumbnail = images.slice(0, 6)
  const imageSize = 190

  const openModal = useCallback((index: number) => {
    setIndex(index)
    setShowModal(true)
  }, [])
  const closeModal = useCallback(() => {
    setShowModal(false)
  }, [])

  return (
    <>
      <div className="w-full pt-3">
        <h3 className="px-3 text-lg font-bold">写真</h3>
        <ul className="mt-3 flex items-center gap-x-2 overflow-x-auto pb-2">
          {imagesForThumbnail.map((image, index) => {
            return (
              // width,heightが必須プロパティとして求められていたため設定しているが、
              // Tailwindで最終的なサイズ調整をしている
              <li
                key={image.url}
                onClick={() => openModal(index)}
                className="block w-24 shrink-0 first:ml-3"
              >
                <Image
                  src={image.url}
                  alt={`${restaurantName} - サムネイル${index + 1}`}
                  className="h-auto flex-1 rounded object-contain"
                  width={imageSize}
                  height={imageSize}
                  usePlaceholder={true}
                />
              </li>
            )
          })}
          {/* 7枚以上の場合もっとみるを表示 */}
          {images.length > 6 && (
            <li className="mr-3 w-20 shrink-0">
              <Link
                to={`/${restaurantId}/photos`}
                preventScrollReset={true}
                prefetch="viewport"
                className="flex flex-col items-center space-y-2"
              >
                <div
                  className={css({
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: 'full',
                    borderWidth: 'thin',
                    borderColor: 'secondary',
                    padding: '1',
                  })}
                >
                  <ChevronRightOutlineIcon
                    height={14}
                    width={14}
                    className={css({ color: 'secondary' })}
                  />
                </div>
                <span className={css({ fontSize: 'xs', color: 'tertiary' })}>もっとみる</span>
              </Link>
            </li>
          )}
        </ul>
      </div>
      <PhotoThumbnailModal
        close={closeModal}
        images={imagesForThumbnail}
        index={index}
        show={showModal}
        seeMore={{
          restaurantId: restaurantId,
          total: images.length,
        }}
      />
    </>
  )
}
